import { Typography, type TypographyProps } from '@mui/material';

export type MHMTypographyProps = TypographyProps & {
  'bold'?: boolean;
  'medium'?: boolean;
  'data-testid'?: string;
};

export const MHMTypography = (props: MHMTypographyProps) => {
  const { bold, medium, children, ...rest } = props;
  const fontWeight = medium ? 'medium' : bold ? 'bold' : undefined;
  return (
    <Typography color="textPrimary" fontWeight={fontWeight} {...rest}>
      {children}
    </Typography>
  );
};

export const ErrorText = (props: MHMTypographyProps) => {
  return (
    <MHMTypography color="error" {...props}>
      {props.children}
    </MHMTypography>
  );
};

export const TitleText = (props: MHMTypographyProps) => {
  return (
    <Typography color="primary" {...props}>
      {props.children}
    </Typography>
  );
};

export function DisclaimerText(props: MHMTypographyProps) {
  return <MHMTypography variant="subtitle1" color="disclaimer" {...props} />;
}
